import { CmsLinkComponent } from '@cms/components/cmsLink/CmsLink'
import type { CmsLink } from '@cms/interfaces/cmsLink'
import { Icon } from '@vista-digital/occ-ui/src'
import { type FC, type RefObject } from 'react'
import type { B2BHeaderAndFooterPropsApi } from '@/features/b2b/b2bHeaderAndFooter.models'
import { cmsDataService } from '../../../services/cms.data.service'
import type { HeaderLinksPropsApi } from './headerLinks/models'
import { NavPageLink } from './headerLinks/subcomponents/NavPageLink'
import { NavSubLinks } from './headerLinks/subcomponents/NavSubLinks'

export interface CmsLinkSub extends CmsLink {
    sublinks?: CmsLink[]
}

export interface NavigationProps {
    isB2B?: boolean
    b2bHeaderAndFooterData?: B2BHeaderAndFooterPropsApi
    selectedLink?: HeaderLinksPropsApi | null
    setSelectedLink: (link: HeaderLinksPropsApi | null) => void
    navItemRefs: RefObject<Map<string, HTMLButtonElement | HTMLAnchorElement>>
}

interface NavLinkProps {
    link: HeaderLinksPropsApi
    navItemRef?: (el: HTMLButtonElement | null) => void
}

export const Navigation: FC<NavigationProps> = ({
    isB2B = false,
    selectedLink = null,
    setSelectedLink,
    b2bHeaderAndFooterData,
    navItemRefs,
}) => {
    const links: HeaderLinksPropsApi[] =
        isB2B && b2bHeaderAndFooterData ? b2bHeaderAndFooterData.headerLinks : cmsDataService.get().headerLinks

    const NavLink: FC<NavLinkProps> = ({ link, navItemRef }) => {
        const isMultilink = !link.singlePageLink

        const handleClick = () => {
            setSelectedLink(selectedLink !== link ? link : null)
        }

        if (!link.primaryPageName) {
            return null
        }

        if (!isMultilink) {
            return (
                <NavPageLink
                    link={link}
                    navItemRef={(el: HTMLAnchorElement | null) => {
                        if (!navItemRefs.current) return

                        if (el) {
                            navItemRefs.current.set(link.primaryPageName, el)
                        } else {
                            navItemRefs.current.delete(link.primaryPageName)
                        }
                    }}
                />
            )
        }

        return (
            <button
                ref={navItemRef}
                onClick={handleClick}
                className={`nav-link nav-multi-link ${selectedLink === link ? 'active' : ''}`}
            >
                {link.primaryPageName}
                <Icon className="nav-arrow" name="arrowRight" />
            </button>
        )
    }

    const b2bCtaLink: CmsLink = cmsDataService.get()?.header?.b2BCTAButton

    return (
        <nav className="header-nav">
            <div id="back-button-placeholder" className="back-button">
                Back Placeholder
            </div>

            {links?.map((link, index) => (
                <NavLink
                    key={`nav-link-${index}`}
                    link={link}
                    navItemRef={el => {
                        if (!navItemRefs.current) return

                        if (el) {
                            navItemRefs.current.set(link.primaryPageName, el)
                        } else {
                            navItemRefs.current.delete(link.primaryPageName)
                        }
                    }}
                />
            ))}

            {selectedLink && <NavSubLinks selectedLink={selectedLink} setSelectedLink={setSelectedLink} />}

            {isB2B && b2bCtaLink && <CmsLinkComponent className="btn btn--primary mobile-cta" link={b2bCtaLink} />}
        </nav>
    )
}
